import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export const Werkproces: React.FC = () => {
  const steps = [{
    title: 'Kennismaking &\nIntake',
    description: 'We starten met een vrijblijvend gesprek om jouw wensen en doelen scherp te krijgen.',
    image: 'https://cdn.magicpatterns.com/uploads/en8rEEVAuGtF8EPzAmyHp6/norden_met_vergrootglas.png'
  }, {
    title: 'Ontwerp &\nFeedback',
    description: 'We maken een persoonlijk design en duidelijke structuur die past bij jouw bedrijf.',
    image: 'https://cdn.magicpatterns.com/uploads/hr1JC9wRjcR2KJD3mjAfSG/Norden_met_kleur_waaier.png'
  }, {
    title: 'Ontwikkeling\n& Testen',
    description: 'Wij bouwen jouw WordPress website met aandacht voor SEO, snelheid en veiligheid.',
    image: 'https://cdn.magicpatterns.com/uploads/k2oc6i7aAK288UUd8m2sTF/Norden_met_tandwiel.png'
  }, {
    title: 'Lancering',
    description: 'Samen lopen we de site door, en optimaliseren we voor conversie en vindbaarheid.',
    image: 'https://cdn.magicpatterns.com/uploads/1WqxCzJ38hFJxSHm98buvx/Norden_met_raket.png'
  }, {
    title: 'Onderhoud & groei',
    description: 'Na livegang houden we de website up-to-date en denken we mee over doorontwikkeling.',
    image: 'https://cdn.magicpatterns.com/uploads/3MuSnfaWEHYo1WZXKtBhAK/Norden_met_plant.png'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 50,
        damping: 15
      }
    }
  };
  return <section className="w-full bg-[#F7F8FA] py-20 md:py-28 overflow-hidden" data-id="element-706">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1400px]" data-id="element-707">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-708">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl lg:text-5xl" data-id="element-709">
            Onze werkwijze
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[#6B7280] text-lg md:text-xl leading-relaxed" data-id="element-710">
            Van eerste gesprek tot succesvolle website. Zo werken wij samen aan
            jouw online succes.
          </motion.p>
        </div>

        {/* Cards Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16" data-id="element-711">
          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative bg-white rounded-2xl p-8 border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-shadow duration-300 flex flex-col items-center text-center overflow-hidden group" data-id="element-712">
              {/* Large Background Number */}
              <div className="absolute -top-4 -right-3 text-9xl font-black text-gray-100/60 z-0 pointer-events-none select-none transform group-hover:scale-110 transition-transform duration-500" data-id="element-713">
                0{index + 1}
              </div>

              {/* Content Container (z-10 to stay above number) */}
              <div className="relative z-10 flex flex-col items-center h-full" data-id="element-714">
                {/* Norden Mascotte */}
                <div className="w-28 h-28 mb-6 flex-shrink-0 flex items-center justify-center" data-id="element-715">
                  <img src={step.image} alt={`Norden: ${step.title.replace('\n', ' ')}`} className="w-full h-full object-contain drop-shadow-md" data-id="element-716" />
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-[#111827] mb-4 whitespace-pre-line leading-tight min-h-[3rem] flex items-center justify-center" data-id="element-717">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-[#6B7280] text-sm leading-relaxed flex-grow" data-id="element-718">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="flex justify-center" data-id="element-719">
          <a href="/werkwijze" className="inline-flex items-center justify-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg group" data-id="element-720">
            Lees onze volledige werkwijze
            <ArrowRightIcon className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" data-id="element-721" />
          </a>
        </motion.div>
      </div>
    </section>;
};